import { t } from 'ember-intl'
import { Tile } from 'teacher-ui-client/components/home/tiles/homeschool/base-tile'
import TileButton from './button.gts'
import GlimmerComponent from '@glimmer/component'
import { service } from '@ember/service'
import type LogoutService from 'teacher-ui-client/services/logout'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Args: {
    src?: string
  }
}

export class HomeschoolTilesVideo extends GlimmerComponent<Signature> {
  @service logout!: LogoutService

  logoutAndRedirectToWebinars = () => {
    void this.logout.logoutAndRedirectToReadingeggs('/parent_ui/homeschool-max/webinars')
  }
  <template>
    <Tile data-test-homeschool-tile-video>
      {{#if @src}}
        <video
          src={{@src}}
          controls
          class="snappy:invisible aspect-video h-3/4 w-full bg-black"
          title={{t "pages.home.panels.homeschool.homeschoolMaxVideo.videoTitle"}}
        >
          <track kind="captions" />
        </video>
      {{else}}
        <iframe
          src="https://player.vimeo.com/video/1082755295?badge=0&amp;transparent=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="snappy:invisible aspect-video h-3/4 w-full"
          title={{t "pages.home.panels.homeschool.homeschoolMaxVideo.videoTitle"}}
        ></iframe>

      {{/if}}

      <div class="flex flex-1 flex-col items-center justify-center px-8 text-center">
        <TileButton
          @title={{t "pages.home.panels.homeschool.homeschoolMaxVideo.buttonText"}}
          @themeKey={{ThemeKeys.blue}}
          @action={{this.logoutAndRedirectToWebinars}}
          data-test-homeschool-family-dashboard-button
        />
      </div>

    </Tile>
  </template>
}

export default HomeschoolTilesVideo
